<template>
  <div :id="this.id" @contextmenu.prevent="handler($event)"
       class="sitebuilder-element-container"
       element="ContentNavUserComponent"
       :data-hide-desktop="!this.internal_config.showDesktop"
       :data-hide-mobile="!this.internal_config.showMobile"
       :config-properties="JSON.stringify(internal_config)" :style="style()" v-on:click="focusElement($event)">

    <vue-draggable-resizable v-bind:w="parseInt(internal_config.width)" v-bind:h="parseInt(internal_config.height)"
                             :minWidth="400" :minHeight="350"
                             @resizing="onResize" :draggable="false" ref="draggableResizable">

      <options-element-bar ref="optionsBar" :elem="this" name='ct-component-ContentNavUserComponent' >
        <img src="../../../../../../static/images/icons/engrenagem.svg"
             v-tooltip="{content:$t('ct-settings'),  class: 'tooltip-custom'}"
             class="svg-icon normal-action"
             @click="settingsElement"/>
      </options-element-bar>

      <div
        class="container-nav-user"
        v-bind:style="{
          height: height, width : width,border: border,'border-radius': radius,background: background,'box-shadow': boxShadow}">
        <ul class="nav nav-pills mb-3" id="pills-tab" role="tablist" ref="tabs">
          <li class="nav-item" v-for="(tab, index) in internal_config.visibleTabs">
            <a class="nav-link" :class="{ 'active': index === 0}" :id="`pills-${tab}-tab`"  :style="getStyleNav(index === 0)" data-toggle="pill" :href="`#pills-${tab}`" role="tab"
               aria-controls="pills-profile" aria-selected="false">
              <template v-if="parseInt(internal_config.iconsEnable) && tab === 'profile'"><i class="mdi mdi-account"></i></template>
              <template v-if="parseInt(internal_config.iconsEnable) && tab === 'areas'"><i class="mdi mdi-folder-lock"></i></template>
              {{ $t(`ct-tab-${tab}`)}}
            </a>
          </li>
        </ul>
        <div class="tab-content" id="pills-tabContent" :style="getStyleNavContent()">
          <div class="tab-pane fade" :class="{ 'show active': index === 0}" :id="`pills-${tab}`"  v-for="(tab, index) in internal_config.visibleTabs" :aria-labelledby="`pills-${tab}-tab`">{{ $t(`ct-${tab}-exemple-content`)}}</div>
        </div>
      </div>
      <resources ref="resourcesData"></resources>
    </vue-draggable-resizable>
  </div>
</template>

<script>

import Data from './Model';
import Resources from './Resources.vue';
import OptionsElementBar from '../../OptionsElementBar';
import MixinComponents from "../../../../../js/mixins/MixinComponents";

export default {
  name: 'ContentNavUserComponent',
  props: ['config', 'id', 'preview', 'device'],
  mixins: [MixinComponents],
  components: {
    OptionsElementBar,
    Resources
  },
  computed: {
    boxShadow() {
      return this.internal_config.tabContent.boxShadow;
    },
    background() {
      return this.internal_config.tabContent.backgroundColor;
    }
  },
  data() {
    return Data.data();
  },
  watch: {
    'internal_config': {
      deep: true,
      handler(value) {
        this.$eventHub.setValueElementConfig(this.id, value);
      }
    }
  },

  methods: {

    animation() {
      return true;
    },

    settingsElement: function() {
      this.$root.$emit('openContentNavUserSettingModal', this, (data) => {
        console.log('container user callback');
      });
    },

    onResize: function(x, y, width, height) {
      this.internal_config.width = width + 'px';
      this.internal_config.height = height + 'px';

      this.$refs.resourcesData.setValuesData(this);
    },

    showResources() {
      return this.$refs.resourcesData.getValuesData();
    },

    formatText(textStyle, active = false) {
      return {
        fontFamily: textStyle.family,
        fontSize: this.device !== 'mobile' ? textStyle.size : textStyle.sizeMobile,
        'text-align': textStyle.align,
        'font-weight': textStyle.weight,
        'font-style': textStyle.style,
        'text-decoration': textStyle.stroke,
        color: (active) ? this.internal_config.tabNav.textColorTabActive : textStyle.color
      };
    },
    style() {
      return `
        left: ${this.internal_config.left};
        paddingTop: ${this.internal_config.paddingTop};
        padding-left: ${this.internal_config.paddingLeft};
        z-index: ${this.internal_config.zIndex};
        max-width: ${this.internal_config.maxWidth};
        margin: 0 auto;
        padding-right: ${this.internal_config.paddingRight};
        padding-bottom: ${this.internal_config.paddingBottom};
        top: ${this.internal_config.top}`;
    },

    getStyleNav(active = false){
      let textStyle = this.formatText(this.internal_config.tabNav.textStyle, active);
      return {
        backgroundColor: (active) ? this.internal_config.tabNav.backgroundTabActiveColor : this.internal_config.tabNav.backgroundTabColor,
        border: this.internal_config.tabNav.border,
        borderRadius: this.internal_config.tabNav.borderRadius,
        boxShadow: this.internal_config.tabNav.boxShadow,
        ...{...textStyle}
      };
    },

    getStyleNavContent() {
      return this.formatText(this.internal_config.tabContent.textStyle);
    },
  },
  created() {
    this.internal_config = Object.assign({}, this.internal_config, window.mergeRecursive(this.props, this.$props.config));

    document.body.style.setProperty('--tab-user-bg-color--hover', this.internal_config.tabNav.backgroundTabHoverColor);
  },

  mounted() {
    this.$refs.resourcesData.setValuesData(this);

    if (this.$props.preview) {
      this.$root.$emit('applyAnimation', this, 'sitebuilder-element-container');
      this.$el.classList.add('preview');
    }
  }
};
</script>

<style scoped lang="scss">

  .tab-content{
    padding: 15px;
  }

  .nav-pills .nav-link{
    min-width: 120px;
  }

  .container-nav-user .nav-pills .nav-link:hover{
    background-color: var(--tab-user-bg-color--hover) !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/editor/apps/Members/ContentNavUser/ContentNavUser.vue